import React, { useState, useEffect, useCallback, useRef } from 'react';
import { RefreshCw, Search } from 'lucide-react';
import axios from 'axios';
import { Badge } from '../ui/badge';
import { BACKEND_URL } from './constants';
import { getToken } from '../../services/tokenService';

export default function SouscriptionLookup({ onSelect }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const timerRef = useRef(null);
  const wrapperRef = useRef(null);
  const headers = { Authorization: `Bearer ${getToken()}` };

  useEffect(() => {
    const h = (e) => { if (wrapperRef.current && !wrapperRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const doSearch = useCallback(async (q) => {
    if (q.length < 2) { setResults([]); return; }
    setLoading(true);
    try {
      const res = await axios.get(`${BACKEND_URL}/api/recus-ess/search-souscriptions?q=${encodeURIComponent(q)}`, { headers });
      setResults(res.data.results || []);
      setOpen(true);
    } catch { setResults([]); } finally { setLoading(false); }
  }, []);

  const handleChange = (val) => { setQuery(val); if (timerRef.current) clearTimeout(timerRef.current); timerRef.current = setTimeout(() => doSearch(val), 300); };

  return (
    <div className="relative" ref={wrapperRef}>
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
        <input type="text" value={query} onChange={e => handleChange(e.target.value)} onFocus={() => results.length > 0 && setOpen(true)}
          placeholder="Ref. Solidaire, raison sociale, SIRET..." className="w-full pl-10 pr-10 py-2.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-orange-500 focus:border-orange-500" data-testid="recu-souscription-search" />
        {loading && <RefreshCw className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 animate-spin text-gray-400" />}
      </div>
      {open && results.length > 0 && (
        <div className="absolute z-50 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-xl max-h-60 overflow-y-auto" data-testid="recu-souscription-dropdown">
          {results.map(sub => (
            <button key={sub.id} type="button" onClick={() => { onSelect(sub); setQuery(`${sub.ref_solidaire} - ${sub.raison_sociale || ''}`); setOpen(false); }}
              className="w-full text-left px-4 py-2.5 hover:bg-orange-50 border-b border-gray-100 last:border-0 transition-colors">
              <div className="flex justify-between items-center">
                <span className="font-semibold text-sm text-gray-900">{sub.ref_solidaire} <span className="text-gray-500 font-normal ml-1">{sub.raison_sociale}</span></span>
                <Badge variant="outline" className="text-xs shrink-0">{sub.statut}</Badge>
              </div>
              <div className="flex gap-3 text-xs text-gray-400 mt-0.5">{sub.siret && <span>SIRET: {sub.siret}</span>}{sub.montant_ttc > 0 && <span>{sub.montant_ttc.toFixed(2)} EUR</span>}</div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
